const INITIAL_STATE = {
    status: 'loading',
    data: [],
}

export default (state = INITIAL_STATE, action) => {
    
    switch (action.type) {
        case 'TAGS_LOADED_TAGS':
            return { ...state, status: 'done', data: action.payload }
        case 'TAGS_STATUS_CHANGED':
            return  { ...state, status: action.payload }  
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/modules/reducers/tagsReducer.js